import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import React from 'react'
import { usePatientFormI18n } from '../utils/patientFormI18n'

export const CommunicationReceiver = ({
  receiver = {},
  index,
  onUpdate,
  onRemove,
  editMode = true,
  validationHook,
}) => {
  const { copy } = usePatientFormI18n()
  const {
    toEmail = '',
    toPhone = '',
    toWhatsAppId = '',
    toUserId = '',
    toPatientId = '',
  } = receiver

  const validation = validationHook?.getCommunicationReceiverValidation?.(index)
  const hasError = validation?.showError

  const handleFieldChange = (field, value) => {
    if (editMode && onUpdate) {
      onUpdate(index, field, value)
    }
  }

  const handleRemove = () => {
    if (editMode && onRemove) {
      onRemove(index)
    }
  }

  const inputStyle = {
    padding: '8px 12px',
    border: '1px solid #ddd',
    borderRadius: '4px',
    fontSize: '14px',
    width: '100%',
  }

  const errorStyle = {
    ...inputStyle,
    borderColor: '#dc3545',
  }

  return (
    <div className="mb-3 p-3" style={{ border: '1px solid #e9ecef', borderRadius: '6px', backgroundColor: '#f8f9fa' }}>
      <div className="d-flex justify-content-between align-items-start mb-2">
        <h6 className="mb-0">{copy.recipientTitle(index)}</h6>
        <DeleteOutlineIcon
          style={{
            cursor: editMode ? 'pointer' : 'not-allowed',
            opacity: editMode ? 1 : 0.5,
            fontSize: '18px',
            color: '#dc3545'
          }}
          onClick={handleRemove}
        />
      </div>

      <div className="row g-2">
        {/* Email Field */}
        <div className="col-12 col-md-6">
          <label className="form-label" style={{ fontSize: '12px', fontWeight: '500', marginBottom: '4px' }}>
            {copy.recipientEmailLabel}
          </label>
          <input
            type="email"
            value={toEmail}
            placeholder={copy.recipientEmailPlaceholder}
            disabled={!editMode}
            style={hasError ? errorStyle : inputStyle}
            onChange={(e) => handleFieldChange('toEmail', e.target.value)}
          />
        </div>

        {/* Phone Field */}
        <div className="col-12 col-md-6">
          <label className="form-label" style={{ fontSize: '12px', fontWeight: '500', marginBottom: '4px' }}>
            {copy.recipientPhoneLabel}
          </label>
          <input
            type="tel"
            value={toPhone}
            placeholder={copy.recipientPhonePlaceholder}
            disabled={!editMode}
            style={hasError ? errorStyle : inputStyle}
            onChange={(e) => handleFieldChange('toPhone', e.target.value)}
          />
        </div>

        {/* WhatsApp ID Field */}
        <div className="col-12 col-md-6">
          <label className="form-label" style={{ fontSize: '12px', fontWeight: '500', marginBottom: '4px' }}>
            {copy.recipientWhatsappLabel}
          </label>
          <input
            type="text"
            value={toWhatsAppId}
            placeholder={copy.recipientWhatsappPlaceholder}
            disabled={!editMode}
            style={hasError ? errorStyle : inputStyle}
            onChange={(e) => handleFieldChange('toWhatsAppId', e.target.value)}
          />
        </div>

        {/* User ID Field */}
        <div className="col-12 col-md-6">
          <label className="form-label" style={{ fontSize: '12px', fontWeight: '500', marginBottom: '4px' }}>
            {copy.recipientUserIdLabel}
          </label>
          <input
            type="text"
            value={toUserId}
            placeholder={copy.recipientUserIdPlaceholder}
            disabled={!editMode}
            style={hasError ? errorStyle : inputStyle}
            onChange={(e) => handleFieldChange('toUserId', e.target.value)}
          />
        </div>

        {/* Patient ID Field */}
        <div className="col-12">
          <label className="form-label" style={{ fontSize: '12px', fontWeight: '500', marginBottom: '4px' }}>
            {copy.recipientPatientIdLabel}
          </label>
          <input
            type="text"
            value={toPatientId}
            placeholder={copy.recipientPatientIdPlaceholder}
            disabled={!editMode}
            style={hasError ? errorStyle : inputStyle}
            onChange={(e) => handleFieldChange('toPatientId', e.target.value)}
          />
        </div>
      </div>

      {/* Validation Error */}
      {hasError && (
        <small className="text-danger mt-2 d-block">
          {validation.errorMessage || copy.recipientValidation}
        </small>
      )}

      {/* Help Text */}
      <small className="text-muted mt-2 d-block">
        {copy.recipientHelper}
      </small>
    </div>
  )
}

export default CommunicationReceiver
